import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  FaArrowRight,
  FaChevronLeft,
  FaChevronRight,
  FaPlayCircle,
  FaPause,
} from "react-icons/fa";
import PortalEntryLink from "../../portal/PortalEntryLink";
import Banner3 from "../../image/Banner3.jpg";
import Banner4 from "../../image/Banner4.jpg";
import banner6 from "../../image/banner6.jpeg";
import banner7 from "../../image/banner7.jpeg";

const SLIDES = [
  {
    id: 1,
    image: Banner3,
    kicker: "S-Tee Schools",
    title: "Every child belongs, every child grows",
    description:
      "Welcome to S-TEE Schools, where your child is known by name and encouraged every step of the way. Our teachers and staff care deeply about each student's journey, helping them discover their strengths and build lasting friendships.",
  },
  {
    id: 2,
    image: Banner4,
    kicker: "Academics",
    title: "Learning that inspires and prepares",
    description:
      "At S-TEE, we blend strong academics with real-world skills. Our classrooms are lively, our teachers are passionate, and we celebrate every milestone together—so students are ready for what's next, in school and in life.",
  },
  {
    id: 3,
    image: banner6,
    kicker: "Admissions",
    title: "Join our school family for 2026/2027",
    description:
      "We're excited to welcome new families! Whether you're visiting our campus or connecting online, we'll guide you through each step and answer your questions—because choosing a school should feel personal and reassuring.",
  },
  {
    id: 4,
    image: banner7,
    kicker: "Community",
    title: "More than a school—this is home",
    description:
      "At S-TEE, we believe in kindness, respect, and growing together. Our students learn to lead, support one another, and make memories that last a lifetime. Here, everyone has a place to shine.",
  },
];

function Hero() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  const toggleVideo = () => setIsVideoPlaying(!isVideoPlaying);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((current) => (current + 1) % SLIDES.length);
    }, 6500);

    return () => clearInterval(timer);
  }, []);

  const goToSlide = (index) => setActiveIndex(index);
  const goNext = () =>
    setActiveIndex((current) => (current + 1) % SLIDES.length);
  const goPrev = () =>
    setActiveIndex(
      (current) => (current - 1 + SLIDES.length) % SLIDES.length
    );

  const activeSlide = SLIDES[activeIndex];

  return (
    <>
      <section className="relative isolate min-h-[88vh] overflow-hidden bg-slate-950 text-white pt-2 pb-4">
        {/* Full-screen background carousel */}
        <div className="absolute inset-0">
          {SLIDES.map((slide, index) => (
            <div
              key={slide.id}
              className={`absolute inset-0 bg-cover bg-center transition-all duration-700 ease-out ${index === activeIndex
                  ? "scale-100 opacity-100"
                  : "scale-105 opacity-0"
                }`}
              style={{ backgroundImage: `url(${slide.image})` }}
            >
              <div className="absolute inset-0 bg-gradient-to-r from-[#09101f]/90 via-[#102046]/76 to-[#102046]/30" />
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(212,164,72,0.28),transparent_34%)]" />
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_right,rgba(31,121,140,0.24),transparent_34%)]" />
            </div>
          ))}
        </div>

        <div className="relative z-10 mx-auto flex min-h-[88vh] w-full max-w-7xl items-center px-6 py-2 md:px-10 lg:px-16">
          <div className="grid w-full gap-12 lg:grid-cols-[1.1fr_0.9fr] lg:items-start">
            {/* Left column — text content */}
            <div className="max-w-3xl">
              <div className="inline-flex items-center gap-3 rounded-full border border-white/15 bg-white/10 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.3em] text-amber-100 backdrop-blur-sm">
                <span className="h-2 w-2 rounded-full bg-amber-300" />
                {activeSlide.kicker}
              </div>
              <h1 className="max-w-3xl text-5xl leading-[0.96] md:text-7xl">
                {activeSlide.title}
              </h1>
              <p className="max-w-2xl text-base text-slate-100/[0.88] md:text-xl">
                {activeSlide.description}
              </p>
              <div className="mt-8 flex flex-wrap gap-4">
                <PortalEntryLink
                  role="applicant"
                  className="inline-flex items-center gap-3 rounded-full bg-[#d4a448] px-7 py-4 text-xs font-bold uppercase tracking-[0.22em] text-slate-950 transition hover:bg-[#e2b65f] md:text-sm"
                >
                  Apply To S-Tee <FaArrowRight />
                </PortalEntryLink>
                <Link
                  to="/academics"
                  className="inline-flex items-center gap-3 rounded-full border border-white/20 bg-white/10 px-7 py-4 text-xs font-bold uppercase tracking-[0.22em] text-white backdrop-blur-sm transition hover:border-white/40 hover:bg-white/15 md:text-sm"
                >
                  Explore Academics
                </Link>
              </div>
              <div className="mt-10 grid gap-4 sm:grid-cols-3">
                <div className="rounded-[1.5rem] border border-white/12 bg-white/[0.08] p-5 backdrop-blur-sm">
                  <p className="text-3xl text-white">Since 1978</p>
                  <p className="mt-2 text-sm uppercase tracking-[0.18em] text-slate-200/75">
                    serving families
                  </p>
                </div>
                <div className="rounded-[1.5rem] border border-white/12 bg-white/[0.08] p-5 backdrop-blur-sm">
                  <p className="text-3xl text-white">Festac</p>
                  <p className="mt-2 text-sm uppercase tracking-[0.18em] text-slate-200/75">
                    Lagos campus
                  </p>
                </div>
                <div className="rounded-[1.5rem] border border-white/12 bg-white/[0.08] p-5 backdrop-blur-sm">
                  <p className="text-3xl text-white">Nursery to Secondary</p>
                  <p className="mt-2 text-sm uppercase tracking-[0.18em] text-slate-200/75">
                    learning pathway
                  </p>
                </div>
              </div>
              <div className="mt-10 flex items-center gap-4">
                <button
                  type="button"
                  onClick={goPrev}
                  aria-label="Previous slide"
                  className="flex h-11 w-11 items-center justify-center rounded-full border border-white/20 bg-white/10 text-white transition hover:border-white/40 hover:bg-white/20"
                >
                  <FaChevronLeft />
                </button>
                <div className="flex items-center gap-2">
                  {SLIDES.map((slide, index) => (
                    <button
                      key={slide.id}
                      type="button"
                      onClick={() => goToSlide(index)}
                      aria-label={`Go to slide ${index + 1}`}
                      className={`h-2.5 rounded-full transition ${index === activeIndex
                          ? "w-10 bg-[#d4a448]"
                          : "w-2.5 bg-white/40 hover:bg-white/70"
                        }`}
                    />
                  ))}
                </div>
                <button
                  type="button"
                  onClick={goNext}
                  aria-label="Next slide"
                  className="flex h-11 w-11 items-center justify-center rounded-full border border-white/20 bg-white/10 text-white transition hover:border-white/40 hover:bg-white/20"
                >
                  <FaChevronRight />
                </button>
              </div>
            </div>

            {/* Right column — info cards */}
            <div className="grid gap-6 lg:justify-self-end">
              <div className="max-w-md rounded-[2rem] border border-white/12 bg-white/10 p-7 backdrop-blur-md shadow-[0_40px_90px_-50px_rgba(0,0,0,0.65)]">
                <p className="text-xs uppercase tracking-[0.32em] text-amber-100/90">
                  Why families choose S-Tee
                </p>
                <h2 className="mt-4 text-3xl leading-tight text-white">
                  A school experience that feels structured, caring, and
                  ambitious
                </h2>
                <div className="mt-6 space-y-4 text-sm text-slate-100/[0.82]">
                  <div className="rounded-2xl border border-white/10 bg-slate-950/20 px-4 py-4">
                    Clear academic guidance that keeps learners focused,
                    supported, and challenged.
                  </div>
                  <div className="rounded-2xl border border-white/10 bg-slate-950/20 px-4 py-4">
                    School culture built around academics, attitude, and
                    appearance in everyday life.
                  </div>
                  <div className="rounded-2xl border border-white/10 bg-slate-950/20 px-4 py-4">
                    Direct pathways for admissions, online school, and parent
                    support when families are ready.
                  </div>
                </div>
                <Link
                  to="/about"
                  className="mt-7 inline-flex items-center gap-3 text-sm font-semibold uppercase tracking-[0.2em] text-amber-100 transition hover:text-white"
                >
                  Discover the S-Tee story <FaArrowRight />
                </Link>
              </div>

              <div className="max-w-md rounded-[2rem] border border-amber-300/20 bg-[#fff7e8] p-6 text-slate-900 shadow-[0_35px_80px_-55px_rgba(212,164,72,0.85)]">
                <div className="flex items-center justify-between gap-4">
                  <div>
                    <p className="text-xs font-bold uppercase tracking-[0.28em] text-[#8b6730]">
                      See S-TEE in action
                    </p>
                    <h3 className="mt-2 text-2xl">Cultural Day Highlights</h3>
                  </div>
                  <FaPlayCircle className="text-3xl text-[#b88429]" />
                </div>
                <div className="mt-4">
                  <div className="aspect-video w-full rounded-xl overflow-hidden shadow-2xl relative group cursor-pointer bg-slate-900/30">
                    {!isVideoPlaying ? (
                      <>
                        <img
                          src="https://img.youtube.com/vi/9E-DnYj36ec/maxresdefault.jpg"
                          alt="S-TEE School Cultural Day 2026 Thumbnail"
                          title="Play S-TEE School Cultural Day 2026"
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                          loading="lazy"
                        />
                        <div
                          className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent flex items-center justify-center opacity-100 group-hover:opacity-80 transition-all duration-300 cursor-pointer"
                          onClick={toggleVideo}
                        >
                          <FaPlayCircle className="text-6xl text-white drop-shadow-lg group-hover:scale-110 transition-all duration-300" />
                        </div>
                      </>
                    ) : (
                      <>
                        <iframe
                          src="https://www.youtube.com/embed/9E-DnYj36ec?autoplay=1&rel=0&modestbranding=1&playsinline=1&controls=1"
                          title="S-TEE School Cultural Day 2026"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          allowFullScreen
                          className="w-full h-full border-0 rounded-xl"
                        />
                        <div className="absolute inset-0 flex items-center justify-center gap-3 p-4 pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                          <div className="pointer-events-auto opacity-0 group-hover:opacity-100 transition-opacity">
                            <button
                              onClick={toggleVideo}
                              className="flex items-center justify-center w-14 h-14 rounded-full bg-white/20 hover:bg-white/40 backdrop-blur-sm text-white text-xl transition-all"
                              aria-label="Pause video"
                              title="Pause"
                            >
                              <FaPause />
                            </button>
                          </div>
                          <div className="ml-auto pointer-events-auto">
                            <a
                              href="https://www.youtube.com/watch?v=9E-DnYj36ec"
                              target="_blank"
                              rel="noopener noreferrer"
                              className="flex items-center justify-center w-12 h-12 rounded-full bg-white/20 hover:bg-white/40 backdrop-blur-sm text-white text-lg transition-all"
                              title="Open in fullscreen"
                            >
                              ⛶
                            </a>
                          </div>
                          <button
                            onClick={toggleVideo}
                            className="flex items-center justify-center w-12 h-12 rounded-full bg-red-500/80 hover:bg-red-600/90 text-white text-lg transition-all ml-auto"
                            aria-label="Close video"
                            title="Close"
                          >
                            ×
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="mt-3 px-1">
                    <p className="text-sm font-semibold text-slate-900 leading-tight line-clamp-2">
                      S-TEE School Cultural Day 2026
                    </p>
                    <div className="flex items-center gap-2 mt-2 text-xs text-slate-600 font-medium">
                      <span>S-TEE Schools</span>
                      <div className="flex-1 h-px bg-slate-300" />
                      <span>3:45</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Hero;
